import { Copy } from "lucide-react";
import { useNotify, useTranslate } from "ra-core";

import { Button } from "@/components/ui/button";
import { getMcpUrl, maskMcpUrl } from "./mcpUrl";
import { settingsRowClass } from "./MobileSettingsList";

/** Copies the MCP URL to the clipboard and confirms it with a toast. */
const useCopyMcpUrl = () => {
  const notify = useNotify();
  const url = getMcpUrl();
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      notify("crm.profile.mcp.copied", { type: "success" });
    } catch {
      notify("crm.profile.mcp.copy_error", { type: "error" });
    }
  };
  return { copy, masked: maskMcpUrl(url) };
};

/** Row of the mobile account settings (iOS grouped list). */
export const McpUrlCopyRow = () => {
  const translate = useTranslate();
  const { copy, masked } = useCopyMcpUrl();
  return (
    <button type="button" className={settingsRowClass} onClick={copy}>
      <Copy
        aria-hidden
        className="size-5 shrink-0 text-[color:var(--settings-secondary)]"
      />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate">{translate("crm.profile.mcp.copy")}</span>
        <span
          className="truncate font-mono text-[13px] text-[color:var(--settings-secondary)]"
          aria-hidden
        >
          {masked}
        </span>
      </span>
    </button>
  );
};

/** Desktop profile page variant. */
export const McpUrlCopyButton = () => {
  const translate = useTranslate();
  const { copy, masked } = useCopyMcpUrl();
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button type="button" variant="outline" onClick={copy}>
        <Copy aria-hidden />
        {translate("crm.profile.mcp.copy")}
      </Button>
      <code className="text-xs text-muted-foreground">{masked}</code>
    </div>
  );
};
